import { hot } from "react-hot-loader";

import React, { useEffect, useState } from "react";
import ButtonAction, {
  buttonActionThemes
} from "@streeteasy/design-system/button-action";
import actionElements from "@streeteasy/design-system/constants/actionElements";
import { number, oneOfType, string } from "prop-types";

import showingTimeUrls from "../../services/urlService";
import * as S from "./styled";

const ManageShowingsLink = ({ saleId }) => {
  const [manageShowingsUrl, setManageShowingsUrl] = useState(null);

  useEffect(() => {
    const fetchManageShowingsUrl = async () => {
      const url = await showingTimeUrls.generateListingConfigurationUrl(saleId);
      setManageShowingsUrl(url);
    };
    fetchManageShowingsUrl(saleId);
  }, [saleId]);

  return (
    manageShowingsUrl && (
      <ButtonAction
        element={actionElements.a}
        href={manageShowingsUrl}
        target="_blank"
        theme={buttonActionThemes.TERTIARY}
      >
        <S.LinkOutIcon />
        Manage showings
      </ButtonAction>
    )
  );
};

ManageShowingsLink.propTypes = {
  saleId: oneOfType([string, number]).isRequired
};

export default hot(module)(ManageShowingsLink);
